import React from 'react';
import {GroupItems} from "components/pages/groups/group-table/group-items/GroupItems";
import {useAppDispatch, useAppSelector} from "common/hook";
import {setGroupsCurrentPage} from "features/model/slice/groups/groupsSlice";
import {Group} from "features/model/types/groups/groupsSchema";
import {Preloader} from "../../../layout/preloader/Preloader";
import {NothingYetMessage} from "../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {CustomPagination} from "components/pagination/CustomPagination";
import {fetchGroups} from "features/model/service/groups/fetchGroups";


export const GroupTable = () => {
    const dispatch = useAppDispatch();
    const groupsState = useAppSelector((state) => state.groups);

    const {groups, isLoading, pagination} = groupsState;

    const {page, pageSize, pageCount} = pagination;




    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchGroups({page: value - 1}));
    };


    return (
        <div className="data-tbl groups-tbl">
            <div className="row thead">
                <div className="col group-name-col">Название группы</div>
                <div className="col level-col">Уровень</div>
                <div className="col students-col">Студенты</div>
                <div className="col company-col">Компания</div>
            </div>


            {isLoading ? (
                <Preloader/>
            ) : (
                groups && groups.length > 0 ? (
                    groups.map((group: Group) => (
                        <GroupItems group={group} key={group.id}/>
                    ))
                ) : (
                    <NothingYetMessage/>
                )
            )}


            {pageCount > 1 && (
                <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle}/>
            )}

        </div>
    );
};

